import styled, { css } from "styled-components";
import Container from "components/core/container";
import Typography from "./core/typography";
import Button from "./core/button";

const EmptyState = ({
  media = "/transaction-empty.svg",
  message,
  primaryLabel = "",
  secondaryLabel = "",
  onPrimaryClick,
  onSecondaryClick,
  size = "large",
}) => {
  return (
    <EmptyStateWrapper size={size}>
      <Container padding={[0, 0, 0, 0]}>
        <img src={media} alt="Sorry, no data!" />
        <Typography variant="h2" textAlign="center">
          {message}
        </Typography>
        <StyledActions>
          {primaryLabel && onPrimaryClick && (
            <Button onClick={() => onPrimaryClick()}>{primaryLabel}</Button>
          )}
          {secondaryLabel && onSecondaryClick && (
            <Button variant="secondary" onClick={() => onSecondaryClick()}>
              {secondaryLabel}
            </Button>
          )}
        </StyledActions>
      </Container>
    </EmptyStateWrapper>
  );
};

const EmptyStateWrapper = styled.div`
  ${(props) =>
    props.size === "large" &&
    css`
      min-height: calc(100vh - 215px);
    `}
  ${(props) =>
    props.size === "medium" &&
    css`
      min-height: auto;
    `}
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    display: block;
    margin: 0 auto 32px auto;
    opacity: 0.66;
  }
  h2 {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    color: #666;
  }
`;

const StyledActions = styled.div`
  display: flex;
  column-gap: 16px;
  max-width: 400px;
  margin: 32px auto 0 auto;
  justify-content: center;
  button {
    min-width: 130px;
  }
`;

export default EmptyState;
